import { Locale } from 'date-fns/locale';
import { addDays, format, subDays } from 'date-fns';
import calendarHeaderStyles from "views/b2bView/components/calendarView/styles/calendarHeader.module.css";
import { v4 as uuid } from "uuid";
import { AppUserRole, Direction, DsLayout } from "shared/constants";
import { useTranslation } from 'react-i18next';
import { Button } from "@ds/ds-snam/react";
import { Textlink } from "@ds/ds-snam/react";
import { CalendarMode } from 'shared/constants';
import { useSelector } from 'react-redux';
import { RootState } from 'state/appStore';
import { AppUser } from 'ooAuth2/appUser';
import useAppUser from 'hooks/useAppUser';



export interface ICalendarModeSelector {
    label: string,
    value: CalendarMode
}

interface ICalendarHeaderProps {
    locale: Locale;//deprecated

    currentDate: Date;
    changeDate: (direction: Direction) => void;

    currentMode: CalendarMode,
    switchMode: (view: CalendarMode) => void;

    showModeSelectors:boolean

}

const CalendarHeader: React.FC<ICalendarHeaderProps> = (props): JSX.Element => {
    const {
        locale,
        currentMode,
        currentDate,
        changeDate,
        switchMode,
        showModeSelectors
    } = props;
    const appUser: AppUser | undefined = useAppUser();
    const appUserRole: AppUserRole | undefined = appUser?.getRole();

    
   
    const { t } = useTranslation(['b2b', 'app']);
    const layoutMode = useSelector((state:RootState)=>{
        return state.dsLayout.mode;
    })
    //TO DO: format based on choosen language, not locale
    const getDateDisplay = () => {
        let display: string = "";
        if (currentMode === CalendarMode.DAY) {
            display = format(currentDate, "dd MMMM yyyy", { locale })
        } else if (currentMode === CalendarMode.WEEK) {
            //display = selectedWeek!;
            //console.log(currentDate)
            const dayOfWeek = currentDate.getDay(); 
            const startDate = subDays(currentDate, (dayOfWeek === 0 ? 6 : dayOfWeek - 1)); //currentDate;
            const endDate = addDays(startDate, 6); //addDays(currentDate, 6);//addWeeks(currentDate, 1);
            const startWeekMonth = format(startDate, 'MMMM', { locale });
            const startWeekDay = format(startDate, 'dd');
            const endWeekMonth = format(endDate, 'MMMM', { locale });
            const endWeekDay = format(endDate, 'dd');
            const endYear = format(endDate, 'yyyy');
            display = `${startWeekDay} ${startWeekMonth} /${endWeekDay} ${endWeekMonth} ${endYear}`;
        } else if (currentMode === CalendarMode.MONTH) {
            display = format(currentDate, 'MMMM yyyy', { locale });
        }
        return display;
    }

    const modeSelectors: ICalendarModeSelector[] = appUserRole === AppUserRole.SHIP_MANAGER
    ? [
        { label: t('calendar.selectorLabels.0'), value: CalendarMode.DAY },
        { label: t('calendar.selectorLabels.1'), value: CalendarMode.WEEK }
    ]
    : [
        { label: t('calendar.selectorLabels.0'), value: CalendarMode.DAY },
        { label: t('calendar.selectorLabels.1'), value: CalendarMode.WEEK },
        { label: t('calendar.selectorLabels.2'), value: CalendarMode.MONTH }
    ];

    const today = new Date();
    const startOfCurrentWeek = subDays(today, (today.getDay() === 0 ? 6 : today.getDay() - 1));
    const endOfNextWeek = addDays(startOfCurrentWeek, 12); 
    const currentWeekStart = subDays(currentDate, (currentDate.getDay() === 0 ? 6 : currentDate.getDay() - 1));

    const minDate = startOfCurrentWeek;
    const maxDate = endOfNextWeek;

    const isShipManager = appUserRole === AppUserRole.SHIP_MANAGER;
    const isDayMode = currentMode === CalendarMode.DAY;
    const isWeekMode = currentMode === CalendarMode.WEEK;

    const disableLeft = isShipManager && (
        (isDayMode && currentDate <= minDate) ||
        (isWeekMode && currentWeekStart <= minDate)
    );
    
    const disableRight = isShipManager && (
        (isDayMode && currentDate >= maxDate) ||
        (isWeekMode && currentWeekStart >= subDays(maxDate, 6)) // perché in modalità WEEK stai mostrando 7 giorni
    );

    return (
        <>
            <div className={calendarHeaderStyles.calendarHeader}>

                <div className={calendarHeaderStyles.dateControls}>
                    <div className={calendarHeaderStyles.dateDisplay} style={{color:layoutMode===DsLayout.DARK_MODE?"white":'black'}}>
                        {getDateDisplay()}
                    </div>

                    <div className={calendarHeaderStyles.dateSwitchers}>
                        <Button
                            buttonUIVariant="secondary"
                            buttonSize="medium"
                            buttonIcon="icon-chevron-left"
                            buttonType="button"
                            buttonAriaLabel="right"
                            resetPair=""
                            isDisabled={disableLeft}
                            onClickEvent={() => {
                                changeDate(Direction.LEFT);
                            }}
                        />

                        <Button
                            buttonUIVariant="secondary"
                            buttonSize="medium"
                            buttonIcon="icon-chevron-right"
                            buttonAriaLabel="right"
                            isDisabled={disableRight}
                            onClickEvent={() => {
                                changeDate(Direction.RIGHT);
                            }}
                        />
                    </div>

                </div>

                {showModeSelectors ?
                    <div className={calendarHeaderStyles.viewControl}>
                        <div style={{color:layoutMode===DsLayout.DARK_MODE?"white":"black",marginTop:'2px'}}>
                            {/*Visualizza per:*/}
                            {t('calendar.headerSelectorTitle')}
                        </div>
                        <ul className={calendarHeaderStyles.modeSelectors}>
                            {modeSelectors.map((mode: ICalendarModeSelector) => {
                                
                                return (
                                    <li
                                        key={uuid()}
                                        onClick={() => switchMode(mode.value)}
                                        style={{color:layoutMode===DsLayout.DARK_MODE?"#C2E9CB":'#1d5d9c'}}
                                    >
                                        {currentMode === mode.value ?
                                            <Textlink textlinkText={mode.label} textlinkTextSize='BIG' textlinkSelected={true}/>
                                        :
                                            <Textlink textlinkText={mode.label} textlinkTextSize='BIG' textlinkSelected={false}/>
                                        }
                                    </li>
                                )
                            })}
                        </ul>
                    </div>
                :
                    <>
                    {/*<div className={calendarHeaderStyles.viewControl}>
                        <div style={{color:layoutMode===DsLayout.DARK_MODE?"white":"black"}}>
                            
                            {t('calendar.headerSelectorTitle')}
                        </div>
                        <ul className={calendarHeaderStyles.modeSelectors}>
                            <li style={{color:layoutMode===DsLayout.DARK_MODE?"#C2E9CB":'#1d5d9c'}}>
                                <span>{modeSelectors[0].label}</span>
                            </li>
                        </ul>
                    </div>*/}
                    </>
                }
            </div>
            

        </>
    );
}

export default CalendarHeader;